import { useEffect, useState } from 'react'
import { Navigate, useLocation } from 'react-router-dom'
import { getProsConsoleSummary } from '../api/prosConsole'

type Props = {
  children: JSX.Element
}

export default function ProsConsoleGuard({ children }: Props) {
  const location = useLocation()
  const [loading, setLoading] = useState(true)
  const [canAccess, setCanAccess] = useState(false)

  useEffect(() => {
    let mounted = true
    setLoading(true)
    getProsConsoleSummary()
      .then((summary) => {
        if (!mounted) return
        setCanAccess(Boolean(summary.can_access_console))
      })
      .catch(() => {
        if (!mounted) return
        setCanAccess(false)
      })
      .finally(() => {
        if (mounted) setLoading(false)
      })
    return () => {
      mounted = false
    }
  }, [location.key])

  if (loading) {
    return <div className="p-4 text-sm text-white/70">Loading Pixe Pros…</div>
  }
  if (!canAccess) {
    return <Navigate to="/pros" replace />
  }
  return children
}

